module.exports = __webpack_public_path__ + "static/src/content/images/processed/thumb/Suits_.04e9895.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/content/images/processed/thumb/Suits_.jpg
// module id = SOkw
// module chunks = 0